// src/services/productService.js
const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

/** універсальний request для JSON */
async function requestJSON(url, options = {}) {
  const res = await fetch(url, {
    headers: {
      ...(options.headers || {}),
      ...(options.body && !(options.body instanceof FormData)
        ? { "Content-Type": "application/json" }
        : {}),
    },
    ...options,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    const err = new Error(`REQUEST_FAILED: ${res.status}`);
    err.status = res.status;
    err.body = text;
    throw err;
  }

  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) return null;
  return res.json();
}

/** request для FormData (multipart) */
async function requestFormData(url, options = {}) {
  const res = await fetch(url, {
    ...options,
    // ВАЖЛИВО: для FormData НЕ ставимо Content-Type вручну (браузер сам поставить boundary)
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    const err = new Error(`REQUEST_FAILED: ${res.status}`);
    err.status = res.status;
    err.body = text;
    throw err;
  }

  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) return null;
  return res.json();
}

/**
 * ✅ Публічний список (БЕЗ прихованих)
 * GET /api/products
 */
export function getPublicProducts() {
  return requestJSON(`${API}/api/products`);
}

/**
 * ✅ Адмінський список (З прихованими)
 * GET /api/products?includeHidden=1
 */
export function getProducts() {
  return requestJSON(`${API}/api/products?includeHidden=1`);
}

/**
 * ✅ Створення товару (multipart/form-data)
 * ProductEditForm якраз це і очікує
 */
export function createProductFD(formData) {
  return requestFormData(`${API}/api/products`, {
    method: "POST",
    body: formData,
  });
}

/**
 * ✅ Оновлення товару (multipart/form-data)
 */
export function updateProductFD(id, formData) {
  return requestFormData(`${API}/api/products/${id}`, {
    method: "PUT",
    body: formData,
  });
}

/**
 * ✅ Видалення товару
 */
export function deleteProduct(id) {
  return requestJSON(`${API}/api/products/${id}`, {
    method: "DELETE",
  });
}

/**
 * ✅ Приховати/показати товар
 * PATCH /api/products/:id/visibility
 * body: { isHidden: true/false }
 */
export function setProductVisibility(id, isHidden) {
  return requestJSON(`${API}/api/products/${id}/visibility`, {
    method: "PATCH",
    body: JSON.stringify({ isHidden }),
  });
}



// // src/services/productService.js
// const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

// /**
//  * Отримати всі продукти
//  */
// export async function getProducts() {
//   const res = await fetch(`${API}/api/products`);
//   if (!res.ok) throw new Error("GET_PRODUCTS_FAILED");
//   return res.json();
// }

